import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  standalone: false,
  selector: 'app-third-party-notices-dialog',
  templateUrl: './third-party-notices-dialog.component.html',
  styleUrls: ['./third-party-notices-dialog.component.scss']
})
export class ThirdPartyNoticesDialogComponent {
  fileContent: string = null;
  isEmptyFile: boolean = false;
  config = "assets/bdscan-3rdpartynotices.txt";

  constructor(
    private readonly http: HttpClient,
    private readonly dialogRef: MatDialogRef<ThirdPartyNoticesDialogComponent> 
  ){
    this.http
      .get(this.config, { responseType: 'text' })
      .subscribe((data) => {       
         const processedContent = data
            .replace(/\\r\\n\\r\\n\\r\\n\\r\\n\\r\\n\\r\\n/, '')
            .replace(/\\n/g, '\n')
            .replace(/\\'/g, "'")
            .replace(/\\"/g, '"')
            .replace(/\\&/g, '&')
            .replace(/\\r/g, '\r')
            .replace(/\\t/g, '\t')
            .replace(/\\b/g, '\b')
            .replace(/\\f/g, '\f');

          if (processedContent.trim().length === 0) {
            this.isEmptyFile = true;
          } else {
            this.fileContent = processedContent;
          }
      });
    }

    onCancelClick(): void {
      this.dialogRef.close();
    }
}